import {Component} from 'react';
import $ from 'jquery';
import createReactClass from 'create-react-class';

import './AppJumbotron.css';
import './Common.css';
import {DESIGN} from '../global/libs/CONFIG.js';
import PropTypes from 'prop-types';

class AppJumbotron extends Component {
  // props: askQuestion, updateJumbotronInput, imageDisplay
  constructor(props) {
    super(props);

    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.updateInput = this.updateInput.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.imageDisplay !== this.props.imageDisplay) {
      // props.imageDisplay is about to be changed
      if (nextProps.imageDisplay === true) {
        this.setState({question: ''});
        if (this.inputField) {
          this.inputField.value = '';
          this.inputField.focus();
        }
        if (this.jumbotronImage) {
          $(this.jumbotronImage).slideDown(10);
        }
      } else {
        if (this.jumbotronImage) {
          $(this.jumbotronImage).slideUp(10);
        }
      }
    }
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.props.askQuestion();
    }
  }

  updateInput(e) {
    this.props.updateJumbotronInput(e.target.value);
  }

  render() {
    let {askQuestion} = this.props;

    let searchGroup = <span />;
    let searchTextArea = (
      <textarea
        autoFocus
        value={this.props.jumbotronInput}
        className="form-control"
        // ref="inputField"
        ref={(node) => (this.inputField = node)}
        type="search"
        placeholder="質問はこちらに入力してください"
        onChange={this.updateInput}
        onKeyPress={this.handleKeyPress}
        style={{resize: 'none'}}
      />
    );

    searchGroup = searchTextArea;

    return (
      <div style={{backgroundColor: DESIGN.JUMBOTRONBKGDCOLOR}} className="jumbotron">
        <div ref={(node) => (this.jumbotronImage = node)} style={{display: 'block'}} className="center">
          {DESIGN.FRONT}
        </div>
        <div>{searchGroup}</div>
        <div className="center">
          <QuestionBtn handleClick={askQuestion} />
        </div>
      </div>
    );
  }
}
AppJumbotron.propTypes = {
  askQuestion: PropTypes.func.isRequired,
  updateJumbotronInput: PropTypes.func.isRequired,
  imageDisplay: PropTypes.bool.isRequired,
  jumbotronInput: PropTypes.string.isRequired
};

let QuestionBtn = createReactClass({
  propTypes: {
    handleClick: PropTypes.func.isRequired
  },

  render: function () {
    return (
      <a
        className="btn btn-lg btn-success jumbotron-btn"
        style={{
          padding: '12px 20px',
          fontSize: 21,
          backgroundColor: DESIGN.JUMBOTRONBTNCOLOR,
          borderColor: DESIGN.JUMBOTRONBTNCOLOR
        }}
        onClick={this.props.handleClick}
      >
        質問する
      </a>
    );
  }
});

export default AppJumbotron;
